import { ChangeEvent, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ModalProps } from '../../../../../../components/modal/modal';
import { validateLang } from '../../../../../../helpers/lang';
import { validate } from '../../../../../../helpers/validate';
import { useLang } from '../../../../../../hooks/use-lang';
import { useToggle } from '../../../../../../hooks/use-toggle';
import { BranchType } from '../../../../../../store/api/branches-api';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useManagerStore } from '../../../../../../store/use-manager-store';

export const useCreateBranchModal = (props: ModalProps) => {
  const { managerProfile } = useManagerStore();
  const { postBranch, isLoading, place, putBranch } = useBranchesStore();
  const [branch, setBranch] = useState<Partial<BranchType>>();
  const { t } = useLang();

  const [params] = useSearchParams();
  const id = params.get('branchId');

  useEffect(() => {
    if (id) setBranch(place?.find((item) => String(item.id) === id));
  }, [id, place]);

  const handleChangeZip = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setBranch((prev) => ({ ...prev, zip: value.toUpperCase() }));
  };

  const handleSubmit = async () => {
    const isValid = validate({
      name: { rule: () => validateLang(branch?.name) },
      address: { rule: () => validateLang(branch?.address) },
      phone: {
        rule: () => (branch?.phone ? branch?.phone.replace(/\D/g, '').length === 11 : true),
      },
    });
    if (!isValid) return;

    if (branch) {
      if (branch.id) {
        await putBranch(branch);
      } else {
        await postBranch(branch);
      }
      setBranch({});
      props.onClose();
    }
  };

  const [openSocials, toggleOpenSocials] = useToggle();

  const handleAddSsid = () => {
    const list = branch?.ssid_whitelist || [];
    setBranch((prev) => ({ ...prev, ssid_whitelist: [...list, ''] }));
  };

  const handleDeleteSsid = (index: number) => {
    const list = branch?.ssid_whitelist || [];
    setBranch((prev) => ({ ...prev, ssid_whitelist: list.filter((_, i) => i !== index) }));
  };

  const handleChangeSsid = (index: number, e: ChangeEvent<HTMLInputElement>) => {
    const list = branch?.ssid_whitelist || [];
    setBranch((prev) => ({
      ...prev,
      ssid_whitelist: list?.map((item, i) => (i === index ? e.target.value : item)),
    }));
  };

  const handleChangeIikoOrganizationId = (e: ChangeEvent<HTMLInputElement>) => {
    setBranch((prev) => ({
      ...prev,
      iiko_organization_id: e.target.value,
    }));
  };

  return {
    branch,
    handleChangeIikoOrganizationId,
    handleChangeZip,
    isLoading,
    t,
    handleSubmit,
    setBranch,
    openSocials,
    toggleOpenSocials,
    managerProfile,
    handleAddSsid,
    handleDeleteSsid,
    handleChangeSsid,
  };
};
